import {Radio} from '@wandb/weave/components';
import React, {useMemo} from 'react';

import {Analytics} from '../../../../services/analytics';
import {
  ColorPaletteOption,
  getColorPaletteOptionTitle,
  getColorPaletteSpectrumOrder,
} from '../../../../util/colors';
import {SettingLabel} from '../components/SettingLabel';
import {
  useMaybeColorPaletteOption,
  useMaybeSemanticLegendRunColorOptions,
  useMaybeUpdateColorPaletteOption,
} from '../hooks';
import {RunColorOptions} from '../types';
import {ColorPalettePreview} from './ColorPalettePreview';

const OPTIONS = [
  ColorPaletteOption.DEFAULT,
  ColorPaletteOption.COMMON_DEUTERONOMALY,
  ColorPaletteOption.OTHER_COLOR_BLIND_PALETTE,
];

export const useWorkspaceSettingsColorPalette = () => {
  const semanticLegendRunColorOptions = useMaybeSemanticLegendRunColorOptions();
  const colorPaletteOption = useMaybeColorPaletteOption();

  // The color palette only applies when we're showing the original run colors
  if (
    semanticLegendRunColorOptions == null ||
    semanticLegendRunColorOptions === RunColorOptions.OriginalProjectColors
  ) {
    if (colorPaletteOption == null || !OPTIONS.includes(colorPaletteOption)) {
      return ColorPaletteOption.DEFAULT;
    }
    return colorPaletteOption;
  }
  return ColorPaletteOption.DEFAULT;
};

export const ColorPalette = () => {
  const colorPaletteOption = useWorkspaceSettingsColorPalette();
  const updateColorPaletteOption = useMaybeUpdateColorPaletteOption();
  const colorPaletteColors = useMemo(
    () => getColorPaletteSpectrumOrder(colorPaletteOption),
    [colorPaletteOption]
  );

  return (
    <div className="flex flex-col">
      <SettingLabel className="w-fit" text="Color palette" />
      <Radio.Root
        aria-label="Color palette"
        name="color-palette"
        onValueChange={(value: string) => {
          const option = OPTIONS.find(option => String(option) === value);
          Analytics.track('Color palette changed', {newValue: option});
          updateColorPaletteOption(option);
        }}
        value={String(colorPaletteOption)}>
        {OPTIONS.map(option => (
          <div key={option} className="flex items-center justify-start">
            <Radio.Item id={String(option)} value={String(option)}>
              <Radio.Indicator />
            </Radio.Item>
            <label htmlFor={String(option)}>
              <span className="mx-8">{getColorPaletteOptionTitle(option)}</span>
            </label>
          </div>
        ))}
      </Radio.Root>
      <ColorPalettePreview
        colors={colorPaletteColors}
        borderClassName="mt-16"
      />
    </div>
  );
};
